import { render, staticRenderFns } from "./WizardContent.vue?vue&type=template&id=08aa7146&scoped=true&"
import script from "./WizardContent.vue?vue&type=script&lang=js&"
export * from "./WizardContent.vue?vue&type=script&lang=js&"
import style0 from "./WizardContent.vue?vue&type=style&index=0&id=08aa7146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aa7146",
  null
  
)

export default component.exports